import React from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { useCollection } from "../useData";
import { resolveImg } from "../api";
import SEO from "../components/SEO";

const Films = () => {
  const films = useCollection("films") || [];
  return (
    <div className="px-6 md:px-10 max-w-[1100px] mx-auto">
      <SEO
        title="Films"
        description="Short films directed by Alice Lisi — Reflusso di Coscienza, Nina until the Stars, Take Me to the Sea. Free to watch."
        path="/films"
      />
      <div className="pt-2 pb-8 flex items-baseline justify-between">
        <span className="font-serif italic text-[color:var(--ink-mute)]">Films — free to watch</span>
        <span className="font-serif text-[color:var(--ink-mute)]">{String(films.length).padStart(2, "0")} titles</span>
      </div>

      <div className="border-t border-[color:var(--line)] pt-10 space-y-24 pb-8 max-w-[720px] mx-auto">
        {films.map((f, i) => (
          <Link to={`/films/${f.id}`} key={f.id} className="tile group block">
            <div className="relative aspect-video bg-[color:var(--paper-2)] overflow-hidden flex items-center justify-center">
              {f.cover ? (
                <img src={resolveImg(f.cover)} alt={f.title} loading="lazy" decoding="async" className="tile-img max-w-full max-h-full object-contain" />
              ) : null}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/25">
                <span className="w-14 h-14 rounded-full bg-[color:var(--paper)]/95 flex items-center justify-center">
                  <Play className="w-4 h-4 ml-0.5" strokeWidth={1.5} fill="currentColor" />
                </span>
              </div>
            </div>
            <div className="mt-4 flex items-baseline justify-between">
              <div className="flex items-baseline gap-4">
                <span className="font-serif text-[color:var(--ink-mute)] counter">0{i + 1}</span>
                <span className="font-serif italic text-xl">{f.title}</span>
                <span className="font-serif text-[color:var(--ink-mute)]">— {f.subtitle}</span>
              </div>
              <span className="font-serif text-[color:var(--ink-mute)]">{f.duration} — {f.year}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Films;
